import { Box, Chip, TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';
import LessMoreforInvoice from '../../../shared_elements/components/LessMoreforInvoice';
import moment from 'moment';
import { dateMonthYearDateFormat } from '../../../constants';
import { numberWithCommas, formatCycles } from '../../../utils';

const UpComingEventsList = ({ item, eventsInfo }) => {
    return (
        <TableRow sx={{ padding: '15px !important' }}>
            <TableCell>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1E293B", letterSpacing: "0.3px" }} >
                        {item?.name?.toUpperCase()}
                    </Typography>
                    <Typography sx={{ fontSize: "12px", color: "#64748B" }} > {eventsInfo?.asset_name} </Typography>
                </Box>
            </TableCell>
            <TableCell className="uet-lsv-start uet-lsv-cell">{item?.last_shop_visit_date ? `${moment(item?.last_shop_visit_date).format(dateMonthYearDateFormat)}` : item?.base_date ? `${moment(item?.base_date).format(dateMonthYearDateFormat)}` : `--`}</TableCell>
            <TableCell className="uet-lsv-cell">{item?.base_date_source === "LSV" ? item?.base_tsn ? numberWithCommas(item?.base_tsn) : "--" : "--"}</TableCell>
            <TableCell className="uet-lsv-cell">{item?.base_date_source === "LSV" ? item?.base_csn ? formatCycles(item?.base_csn) : "--" : "--"}</TableCell>
            <TableCell className="uet-lsv-end uet-lsv-cell">{item?.cost ? numberWithCommas(item?.cost) : '--'}</TableCell>

            <TableCell className="uet-nsv-start uet-nsv-cell">{item?.upcoming_date ? moment(item?.upcoming_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
            <TableCell className="uet-nsv-cell">{item?.upcoming_tsn ? numberWithCommas(item?.upcoming_tsn) : "--"}</TableCell>
            <TableCell className="uet-nsv-cell">{item?.upcoming_csn ? formatCycles(item?.upcoming_csn) : "--"}</TableCell>
            <TableCell className="uet-nsv-end uet-nsv-cell">{item?.upcoming_cost ? numberWithCommas(item?.upcoming_cost) : "--"}</TableCell>

            <TableCell>
                {item?.intervals?.months?.interval || item?.intervals?.cycles?.interval || item?.intervals?.hours?.interval ?
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', }} >
                        {item?.intervals?.hours?.interval ? <Chip label={`FH : ${numberWithCommas(item?.intervals?.hours?.interval)}`} variant='outlined' size='small' color='primary' sx={{ fontSize: '11px', height: 'auto', p: 0, '& .MuiChip-label': { px: 0, py: 0, lineHeight: 1.8 } }} /> : null}
                        {item?.intervals?.cycles?.interval ? <Chip label={`FC: ${formatCycles(item?.intervals?.cycles?.interval)}`} variant='outlined' size='small' color='primary' sx={{ fontSize: '11px', height: 'auto', p: 0, '& .MuiChip-label': { px: 0, py: 0, lineHeight: 1.8 } }} /> : null}
                        {item?.intervals?.months?.interval ? <Chip label={`Months: ${item?.intervals?.months?.interval}`} variant='outlined' size='small' color='primary' sx={{ fontSize: '11px', height: 'auto', p: 0, '& .MuiChip-label': { px: 0, py: 0, lineHeight: 1.8 } }} /> : null}
                    </Box>
                    : '--'}
            </TableCell>
            <TableCell sx={{ maxWidth: '200px !important' }}>
                <LessMoreforInvoice
                    value={item?.notes?.length > 0 ? item?.notes?.join(', ') : '--'}
                />
            </TableCell>
        </TableRow>

    )
}

export default UpComingEventsList;